import { ROLE_REASON_LABELS, TOOL_ERROR_LABELS } from "./v2AgentLoop.labels"

export const DELIVERY_REASONS: Record<string, string> = {
  SEND: "Cevap müşteriye gönderildi",
  SEND_AND_HANDOFF:
    "Cevap gönderildi; ajan ayrıca bir temsilci gerektiğine karar verdiği için konuşma devredildi",
  HANDOFF_SILENT:
    "Ajan bu mesajın temsilci gerektirdiğine karar verdi; cevap yazmadan konuşmayı devretti",
  SPAM: "Ajan mesajı spam olarak sınıflandırdı; mesaj spam işaretlendi, cevap gönderilmedi",
  SPAM_NOT_CONFIGURED:
    "Ajan mesajı spam saydı ama AI profilinde spam aksiyonu tanımlı değil; mesaj işaretlenmedi, cevap gönderilmedi",
  NO_REPLY:
    "Ajan bu mesajın cevap gerektirmediğine karar verdi (ör. yalnızca emoji ya da tekrar eden mesaj)",
  SINGLE_REPLY_WITHHELD:
    "Bu kanal tek cevap hakkı veriyor (yorum, özel cevap, pazaryeri sorusu). Ajan eksiksiz ve doğrulanmış bir cevap veremeyeceği için devretmeyi ya da soru sormayı seçti veya cevap pazaryeri kurallarına takıldı; hiçbir şey gönderilmedi, cevap temsilciye bırakıldı",
  EMPTY_REPLY_WITHHELD:
    "Ajan cevap verdiğini söyledi ama metin boştu; boş mesaj gönderilmedi",
  QUOTA_EXHAUSTED: "AI yanıt kotası veya bakiyesi yetersiz; cevap üretilmedi"
}

export const PRODUCT_MATCH_REASONS: Record<string, string> = {
  MATCHED: "Sorulan ürün katalogda bulundu",
  MATCHED_NOT_SELLABLE:
    "Ürün katalogda bulundu ama şu an satın alınabilir varyantı yok",
  NO_MATCH: "Ürün katalogda eşleşmedi",
  AMBIGUOUS: "Birden fazla ürün eşleşti; hangisi olduğu kesinleşmedi",
  NO_MARKETPLACE_SHOP: "Bu pazaryeri için bağlı bir mağaza yok",
  NO_REFERENCE: "Mesajda ilan numarası veya ürün referansı yoktu",
  NOT_A_PRODUCT_URL: "Müşterinin açık olan sayfası bir ürün sayfası değil",
  NO_PAGE_URL:
    "Müşterinin açık olan sayfa adresi gelmedi; sayfadaki ürün aranmadı",
  CACHE_HIT:
    "Bu sayfanın ürünü daha önce eşleştirilmişti; kayıtlı sonuç kullanıldı",
  CACHE_HIT_NO_MATCH:
    "Bu sayfa daha önce denenmiş ve ürün eşleşmemişti; kayıtlı sonuç kullanıldı"
}

export const COMPLIANCE_REASONS: Record<string, string> = {
  EXTERNAL_REDIRECT:
    "Cevap link içeriyordu veya müşteriyi pazaryeri dışına yönlendiriyordu",
  CONTACT_DETAILS:
    "Cevap telefon, e-posta veya mesajlaşma iletişim bilgisi içeriyordu",
  UNGROUNDED_NUMBER:
    "Cevap bu turun verisinin desteklemediği bir rakam belirtiyordu",
  ABSOLUTE_PROMISE:
    "Cevap doğrulanamayan bir teslimat, stok veya fiyat taahhüdü veriyordu",
  PROMOTIONAL:
    "Cevap pazaryerinin yasakladığı reklam veya abartılı pazarlama dili içeriyordu",
  HEALTH_CLAIM: "Cevap sağlık veya tıbbi iddia içeriyordu",
  LEGAL_CLAIM:
    "Cevap hukuki veya ürün güvenliği konusunda kesin hüküm veriyordu",
  INAPPROPRIATE: "Cevap uygunsuz ifade içeriyordu",
  PERSONAL_DATA: "Cevap kişisel veriyi tekrar ediyordu",
  LENGTH_LIMIT: "Cevap pazaryerinin cevap uzunluğu sınırını aşıyordu"
}

const STEP_CODE_TABLES: Record<string, Record<string, string>> = {
  DELIVERY_GATE: DELIVERY_REASONS,
  ROLE_SELECTION: ROLE_REASON_LABELS,
  COMMERCE_MARKETPLACE_PRODUCT_RESOLVE: PRODUCT_MATCH_REASONS,
  COMMERCE_PAGE_PRODUCT_RESOLVE: PRODUCT_MATCH_REASONS,
  MARKETPLACE_COMPLIANCE_GATE: COMPLIANCE_REASONS
}

const CODE_ONLY = /^[A-Z][A-Z0-9_]+$/
const TRAILING_CODE = /^(.*?)\s*\(([A-Z][A-Z0-9_]+)\)$/

export function explainStepCode(step: string, code: string): string | null {
  return STEP_CODE_TABLES[step]?.[code] ?? TOOL_ERROR_LABELS[code]?.text ?? null
}

/** A step's summary or reason with every known code spelled out: "açıklama (CODE)". */
export function readableStepText(
  step: string,
  text: string | null | undefined
): string {
  if (!text) return ""
  if (CODE_ONLY.test(text)) {
    const explained = explainStepCode(step, text)
    return explained ? `${explained} (${text})` : text
  }
  const match = TRAILING_CODE.exec(text)
  const explained = match ? explainStepCode(step, match[2]) : null
  if (!match || !explained) return text
  return match[1]
    ? `${match[1]} — ${explained} (${match[2]})`
    : `${explained} (${match[2]})`
}
